<sc-padding>
  <form [formGroup]="formGroup" class="no-field-space">
    <sc-flex [vertical]="true" [stretchContent]="true" >
      <sc-flex-fitting-content [vertical]="true">
      <sc-string-field [required]="true" formControlName="recipients" maxlength="1024"
        [label]="'firstname' | translate: ['tmc-yard.entity.filter-mail-schedule.recipients', translationService.language]"></sc-string-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-radio-group aria-label="Format" formControlName="exportType">
        Format
        <mat-radio-button value="XLS">XLS</mat-radio-button>
        <mat-radio-button class="margin-left" value="CSV">CSV</mat-radio-button>
      </mat-radio-group>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-checkbox formControlName="periodic">
        {{'periodic' | translate: ['tmc-yard.entity.filter-mail-schedule.periodic', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-number-field formControlName="periodicInterval" [required]="filterMailSchedule.periodic" [disabled]="!filterMailSchedule.periodic" maxlength="4"
        [label]="'periodicInterval' | translate: ['tmc-yard.entity.filter-mail-schedule.periodicInterval', translationService.language]"></sc-number-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <sc-time-field formControlName="timeOfDay" [required]="!filterMailSchedule.periodic" [disabled]="filterMailSchedule.periodic"
        [label]="'time of day' | translate: ['tmc-yard.entity.filter-mail-schedule.time-of-day', translationService.language]"></sc-time-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-checkbox formControlName="monday" [disabled]="filterMailSchedule.periodic">
        {{'monday' | translate: ['tmc-yard.entity.filter-mail-schedule.monday', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-checkbox formControlName="tuesday" [disabled]="filterMailSchedule.periodic">
        {{'tuesday' | translate: ['tmc-yard.entity.filter-mail-schedule.tuesday', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-checkbox formControlName="wednesday" [disabled]="filterMailSchedule.periodic">
        {{'wednesday' | translate: ['tmc-yard.entity.filter-mail-schedule.wednesday', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-checkbox formControlName="thursday" [disabled]="filterMailSchedule.periodic">
        {{'thursday' | translate: ['tmc-yard.entity.filter-mail-schedule.thursday', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-checkbox formControlName="friday" [disabled]="filterMailSchedule.periodic">
        {{'friday' | translate: ['tmc-yard.entity.filter-mail-schedule.friday', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-checkbox formControlName="saturday" [disabled]="filterMailSchedule.periodic">
        {{'saturday' | translate: ['tmc-yard.entity.filter-mail-schedule.saturday', translationService.language]}}
      </mat-checkbox>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-checkbox formControlName="sunday" [disabled]="filterMailSchedule.periodic">
        {{'sunday' | translate: ['tmc-yard.entity.filter-mail-schedule.sunday', translationService.language]}}
      </mat-checkbox>
    </sc-flex-fitting-content>
    </sc-flex>
  </form>
</sc-padding>
